<template>
  <!-- <div v-if="loading || !init">загружаем</div> -->
  <v-app v-if="!loading && $store.state.isInit" :theme="theme">
    <!-- <Auth v-if="!$store.state.auth"></Auth>
    <Main v-else></Main> -->

    <router-view></router-view>
  </v-app>
</template>

<script>
// import Auth from "./components/Auth.vue";
// import Main from "./components/Main.vue";
import axios from "axios";

export default {
  name: "App",

  data: () => ({
    theme: "light",
    user: {},
    interval: -1,
    value: 0,
    loading: false,
    mailboxSetting: [],
  }),
  methods: {
    checkSystemTheme() {
      // Проверяем, поддерживает ли браузер определение темы
      if (window.matchMedia) {
        const isDarkMode = window.matchMedia(
          "(prefers-color-scheme: dark)"
        ).matches;
        return isDarkMode ? "dark" : "light";
      }
      // Если не поддерживается, возвращаем тему по умолчанию (например, светлую)
      return "light";
    },
    async auth(
      login,
      pass,
      selectServer,
      type = "new",
      oauth = "imap",
      refresh = ""
    ) {
      this.loading = true;
      console.log("test 2");
      // kvgncxfnggvuzrvy

      let formData = new FormData();
      formData.append(`params`, "checkConnectImap");
      formData.append(`login`, login);
      formData.append(`password`, pass);
      formData.append(
        `host`,
        oauth == "imap"
          ? this.$store.state.settings[selectServer].imap.address
          : this.$store.state.settings[selectServer].host
      );
      formData.append(
        `port`,
        this.$store.state.settings[selectServer].imap.port
      );
      formData.append(`encrypt`, "ssl");
      formData.append(`type`, oauth == "imap" ? "password" : "oauth");

      const isAuth = await axios.post("https://email.rcgit.ru/imap/", formData);
      console.log(isAuth);

      if (isAuth.data == 1) {
        if (type == "new") {
          const mailbox = {
            title: login,
            icon: "",
            pass,
            refresh,
            server: selectServer,
            encrypt: "ssl",
            type: oauth == "imap" ? "password" : "oauth",
            folders: [],
          };
          // this.$store.commit("mailboxSettingAdd", mailbox);
          await this.$store.commit("mailboxAdd", mailbox);

          if (window.BX24) {
            console.log("Библиотека Bitrix24 загружена");
            window.BX24.init(async () => {
              const callBXMethod = (method, params) =>
                new Promise((resolve, reject) => {
                  window.BX24.callMethod(method, params, function (result) {
                    if (result.error()) {
                      reject(result.error());
                    } else {
                      resolve(result.data());
                    }
                  });
                });
              const mailboxUser = await callBXMethod("entity.item.get", {
                ENTITY: "MailFlow",
                FILTER: {
                  PROPERTY_email: mailbox.title,
                },
                START: -1,
              });
              console.log({ mailboxUser });
              if (mailboxUser.length > 0) {
                console.log(mailboxUser);
                const resUpdate = await callBXMethod("entity.item.update", {
                  ENTITY: "MailFlow",
                  ID: mailboxUser[0].ID,
                  NAME: this.user.ID,
                  PROPERTY_VALUES: {
                    email: mailbox.title,
                    pass: mailbox.pass,
                    server: mailbox.server,
                    refresh: mailbox.refresh,
                  },
                });
                console.log({ resUpdate });
              } else {
                const resAdd = await callBXMethod("entity.item.add", {
                  ENTITY: "MailFlow",
                  NAME: this.user.ID,
                  PROPERTY_VALUES: {
                    email: mailbox.title,
                    pass: mailbox.pass,
                    server: mailbox.server,
                    refresh: mailbox.refresh,
                    //userID: this.user.ID,
                  },
                });
                console.log({ resAdd });
              }
            });
          } else {
            const formDataString = JSON.stringify(this.$store.state.mailbox);
            // Сохраняем строку в localStorage
            await localStorage.setItem("imapSettings", formDataString);
          }
        }
        await this.$store.commit("setAuth", true);

        // this.$store.commit("setSelectNav", [
        //   localStorage.getItem("imapSettings")[0],
        // ]);
      } else {
        alert("Не верный логин или пароль!");
      }
      this.loading = false;
    },
    async refreshWithMailRu() {
      try {
        console.log("refreshToken mail");
        const params = new URLSearchParams();
        params.append("type", "mailRu");
        params.append("client_id", this.$store.state.settings.Mailru.clientId);
        params.append(
          "refresh_token",
          this.$store.state.mailboxSetting[0].refresh
        );
        console.log({ params });
        const response = await axios.post(
          "https://spa-bitrix.ru/marketPlace_mail-app/src/refreshToken.php",
          params,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        console.log({ response });
        this.mailboxSetting[0].pass = response.data.access_token;
        this.$store.commit("mailboxSettingStart", this.mailboxSetting);
        this.$store.commit("mailboxAddStart", this.mailboxSetting);

        await this.auth(
          this.$store.state.mailboxSetting[0].title,
          this.$store.state.mailboxSetting[0].pass,
          this.$store.state.mailboxSetting[0].server,
          "old",
          "oauth",
          this.$store.state.mailboxSetting[0].refresh
        );
        this.loading = false;
      } catch (e) {
        console.log(e);
      }
    },
    async refreshWithYandex() {
      try {
        console.log("refresh ya");
        const tokenUrl = "https://oauth.yandex.ru/token";
        const params = new URLSearchParams();
        params.append("grant_type", "refresh_token");
        params.append(
          "refresh_token",
          this.$store.state.mailboxSetting[0].refresh
        );
        params.append("client_id", this.$store.state.settings.Yandex.clientId);
        params.append(
          "client_secret",
          this.$store.state.settings.Yandex.client_secret
        );

        const response = await axios.post(tokenUrl, params, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        });

        const { access_token, refresh_token } = response.data;

        this.mailboxSetting[0].pass = access_token;
        this.mailboxSetting[0].refresh = refresh_token;
        this.$store.commit("mailboxSettingStart", this.mailboxSetting);
        this.$store.commit("mailboxAddStart", this.mailboxSetting);

        await this.auth(
          this.$store.state.mailboxSetting[0].title,
          this.$store.state.mailboxSetting[0].pass,
          this.$store.state.mailboxSetting[0].server,
          "old",
          "oauth",
          this.$store.state.mailboxSetting[0].refresh
        );
        this.loading = false;
      } catch (error) {
        console.log({ error });
      }
    },
  },
  async created() {
    this.$store.commit("setHeight", window.innerHeight);
    if (window.innerWidth < 800) this.$store.commit("setMobileStatus", true);
    else this.$store.commit("setDesctopStatus", true);
    this.theme = this.checkSystemTheme(); // Устанавливаем тему системы
    if (window.BX24) {
      console.log("Библиотека Bitrix24 загружена");
      window.BX24.init(async () => {
        const callBXMethod = (method, params) =>
          new Promise((resolve, reject) => {
            window.BX24.callMethod(method, params, function (result) {
              if (result.error()) {
                reject(result.error());
              } else {
                resolve(result.data());
              }
            });
          });
        this.user = await callBXMethod("user.current", {});
        console.log(this.user);

        if (!this.$store.state.isNewBox) {
          const entitys = await callBXMethod("entity.item.get", {
            ENTITY: "MailFlow",
            FILTER: {
              NAME: this.user.ID,
            },
            start: -1,
          });
          if (entitys.length > 0) {
            this.loading = true;
            this.interval = setInterval(() => {
              if (this.value === 100) {
                return (this.value = 0);
              }
              this.value += 10;
            }, 1000);

            const mailboxSetting = [];
            for (const entity of entitys) {
              console.log({ entity });
              mailboxSetting.push({
                title: entity.PROPERTY_VALUES.email,
                pass: entity.PROPERTY_VALUES.pass,
                server: entity.PROPERTY_VALUES.server,
                refresh: entity.PROPERTY_VALUES.refresh,
              });
            }
            console.log(mailboxSetting, "mailbox bitrix");

            const entitysALL = await callBXMethod("entity.item.get", {
              ENTITY: "MailFlow",
              FILTER: {},
              start: -1,
            });
            console.log({ entitysALL });
            this.$store.commit("mailboxSettingStart", mailboxSetting);
            this.$store.commit("mailboxAddStart", mailboxSetting);

            await this.auth(
              this.$store.state.mailboxSetting[0].title,
              this.$store.state.mailboxSetting[0].pass,
              this.$store.state.mailboxSetting[0].server,
              "old",
              "imap",
              this.$store.state.mailboxSetting[0].refresh
            );

            this.loading = false;
            this.$store.state.isInit = true;
          }
        }
      });
    } else {
      console.error("Библиотека Bitrix24 не загружена");
      if (localStorage.getItem("imapSettings") && !this.$store.state.isNewBox) {
        this.loading = true;
        this.interval = setInterval(() => {
          if (this.value === 100) {
            return (this.value = 0);
          }
          this.value += 10;
        }, 1000);

        this.mailboxSetting = JSON.parse(localStorage.getItem("imapSettings"));
        console.log(this.mailboxSetting, "mailbox local");

        // Проверяем, используется ли OAuth
        if (this.mailboxSetting[0].type === "oauth") {
          console.log("oauth");
          // Пытаемся использовать сохраненный токен
          try {
            this.mailboxSetting[0].pass,
              this.mailboxSetting[0].server.toLowerCase();
            this.$store.commit("mailboxSettingStart", this.mailboxSetting);
            this.$store.commit("mailboxAddStart", this.mailboxSetting);

            await this.auth(
              this.$store.state.mailboxSetting[0].title,
              this.$store.state.mailboxSetting[0].pass,
              this.$store.state.mailboxSetting[0].server,
              "old",
              "oauth",
              this.$store.state.mailboxSetting[0].refresh
            );
            this.loading = false;
            this.$store.state.isInit = true;
            return;
          } catch (error) {
            console.error("Ошибка проверки токена:", error);
          }

          // Если токен невалиден, запускаем процесс OAuth обновления
          switch (this.$store.state.mailboxSetting[0].server) {
            case "Yandex":
              await this.refreshWithYandex();
              break;
            case "Mailru":
              await this.refreshWithMailRu();
              break;
            case "Google":
              await this.refreshWithGoogle();
              break;
          }
        } else {
          console.log("imap");
          // Обычная IMAP авторизация
          this.$store.commit("mailboxSettingStart", this.mailboxSetting);
          this.$store.commit("mailboxAddStart", this.mailboxSetting);

          await this.auth(
            this.$store.state.mailboxSetting[0].title,
            this.$store.state.mailboxSetting[0].pass,
            this.$store.state.mailboxSetting[0].server,
            "old",
            "imap",
            this.$store.state.mailboxSetting[0].refresh
          );
        }
        this.loading = false;
        this.$store.state.isInit = true;
      }
    }

    this.$store.state.isInit = true;
  },
};
</script>
<style>
body {
  font-family: "SF UI Display", sans-serif;
}
body {
  background-color: #fff !important;
  padding: 0 !important;
}
</style>
